// extracted by mini-css-extract-plugin
export default {"loader_container":"Loader_loader_container__YvKO5","spinner":"Loader_spinner__NIhhh","spin":"Loader_spin__uxcft","text":"Loader_text__9lYtv"};